
import Blockly from 'blockly/core';

var dropdownMutator = {
    mutationToDom: function () {
        var container = Blockly.utils.xml.createElement("mutation");
        
        // Save the currently selected option
        container.setAttribute("value", this.getFieldValue("FIELD_NAME"));
        container.setAttribute("keyValue", this.getFieldValue("KEY_NAME"));
        container.setAttribute("collectionValue", this.getFieldValue("COLLECTION_NAME"));
        container.setAttribute("mapValue", this.getFieldValue("R_KEY_NAME"));
        container.setAttribute("projectNameValues", this.getFieldValue("projectName"));
        container.setAttribute("appbuilderIDValues", this.getFieldValue("appbuilderID"));
        container.setAttribute("destinationFieldVlaues", this.getFieldValue("destinationName"));
        container.setAttribute("newValue", this.getFieldValue("NEW_FIELD_NAME"));
        container.setAttribute("newNameValue", this.getFieldValue("VALUE_NAME"));
        container.setAttribute("nameValue", this.getFieldValue("NAME_MAP"));
        // save all the options here
        var options = [];
        if(this.getField("FIELD_NAME")) {
            options = this.getField("FIELD_NAME").getOptions(false);
            for (var i = 0; i < options.length; i++) {
                var option_element = Blockly.utils.xml.createElement("option");
                option_element.setAttribute("display-value", options[i][0]);
                option_element.setAttribute("neutral-value", options[i][1]);
                container.appendChild(option_element);
            }
        } else if(this.getField("COLLECTION_NAME")) {
            options = this.getField("COLLECTION_NAME").getOptions(false);
            for (var i = 0; i < options.length; i++) {
                var option_element = Blockly.utils.xml.createElement("option1");
                option_element.setAttribute("display-value", options[i][0]);
                option_element.setAttribute("neutral-value", options[i][1]);
                container.appendChild(option_element);
            }
        }
        if(this.getField("R_KEY_NAME")) {
            options = this.getField("R_KEY_NAME").getOptions(false);
            for (var i = 0; i < options.length; i++) {
                var option_element = Blockly.utils.xml.createElement("option2");
                option_element.setAttribute("display-value", options[i][0]);
                option_element.setAttribute("neutral-value", options[i][1]);
                container.appendChild(option_element);
            }
        }
        if (this.getField("projectName")) {
            options = this.getField("projectName").getOptions(false);
            for (var i = 0; i < options.length; i++) {
                var option_element = Blockly.utils.xml.createElement("option3");
                option_element.setAttribute("display-value", options[i][0]);
                option_element.setAttribute("neutral-value", options[i][1]);
                container.appendChild(option_element);
            }
        }
        if (this.getField("appbuilderID")) {
            options = this.getField("appbuilderID").getOptions(false);
            for (var i = 0; i < options.length; i++) {
                var option_element = Blockly.utils.xml.createElement("option4");
                option_element.setAttribute("display-value", options[i][0]);
                option_element.setAttribute("neutral-value", options[i][1]);
                container.appendChild(option_element);
            }
        }
        if (this.getField("destinationName")) {
            options = this.getField("destinationName").getOptions(false);
            for (var i = 0; i < options.length; i++) {
                var option_element = Blockly.utils.xml.createElement("option5");
                option_element.setAttribute("display-value", options[i][0]);
                option_element.setAttribute("neutral-value", options[i][1]);
                container.appendChild(option_element);
            }
        }
        if(this.getField("NEW_FIELD_NAME")) {
            options = this.getField("NEW_FIELD_NAME").getOptions(false);
            for (var i = 0; i < options.length; i++) {
                var option_element = Blockly.utils.xml.createElement("option");
                option_element.setAttribute("display-value", options[i][0]);
                option_element.setAttribute("neutral-value", options[i][1]);
                container.appendChild(option_element);
            }
        }
        

       

        // For debugging
        console.log("mutationToDom");
        console.dirxml(container);
      
        return container;
    },

    domToMutation: function (containerElement) {
        // If set then used by generateOptions in order to provide the list of options 
        this.mutator_saved = [["none", "none"]];

        // Add all the saved options to the mutator-saved list;
        for (var i = 0; i < containerElement.childNodes.length; i++) {
            if (containerElement.childNodes[i] && containerElement.childNodes[i].nodeName != '#text') {
                var option_element = containerElement.childNodes[i];
                this.mutator_saved.push([option_element.getAttribute("display-value"), option_element.getAttribute("neutral-value")])
            }
        }

        // Force set the currently selected option
        if(this.getField("FIELD_NAME")) {
            this.getField("FIELD_NAME").generatedOptions_ = this.mutator_saved;
        }
        if(this.getField("COLLECTION_NAME")) {
            this.getField("COLLECTION_NAME").generatedOptions_ = this.mutator_saved;
        }

        if(this.getField("R_KEY_NAME")) {
            this.getField("R_KEY_NAME").generatedOptions_ = this.mutator_saved;
        }
        if(this.getField("KEY_NAME") && containerElement.getAttribute("keyValue") != 'null' && containerElement.getAttribute("keyValue") != '') {
            this.getField("KEY_NAME").generatedOptions_ = this.mutator_saved;
        } else {
            if(this.getInput('CUSTOM_RESPONSE')) {
                this.getInput('CUSTOM_RESPONSE').removeField('KEY_NAME',true);
                this.getInput('CUSTOM_RESPONSE').removeField("SET_KEY",true);
            }
        }
        if (this.getField("projectName")) {
            this.getField("projectName").generatedOptions_ = this.mutator_saved;
        }
        if (this.getField("appbuilderID")) {
            this.getField("appbuilderID").generatedOptions_ = this.mutator_saved;
        }
        if (this.getField("destinationName")) {
            this.getField("destinationName").generatedOptions_ = this.mutator_saved;
        }
        if(this.getField("NEW_FIELD_NAME")) {
            this.getField("NEW_FIELD_NAME").generatedOptions_ = this.mutator_saved;
        }
        if(this.getField("VALUE_NAME") && containerElement.getAttribute("newNameValue") != 'null' && containerElement.getAttribute("newNameValue") != '') {
            this.getField("VALUE_NAME").generatedOptions_ = this.mutator_saved;
        } else {
            if(this.getInput('New_CUSTOM_RESPONSE')) {
                this.getInput('New_CUSTOM_RESPONSE').removeField('VALUE_NAME',true);
                this.getInput('New_CUSTOM_RESPONSE').removeField("SET_VALUE",true);
            }
        }
        if(this.getField("NAME_MAP") && containerElement.getAttribute("nameValue") != 'null' && containerElement.getAttribute("nameValue") != '') {
            this.getField("NAME_MAP").generatedOptions_ = this.mutator_saved;
        } else {
            if(this.getInput('New_CUSTOM_RESPONSE')) {
                this.getInput('New_CUSTOM_RESPONSE').removeField('NAME_MAP',true);
                this.getInput('New_CUSTOM_RESPONSE').removeField("SET_KEY_NAME",true);
            }
        }
    }
}

Blockly.Extensions.registerMutator("dropdown_mutator", dropdownMutator);


// WEBPACK FOOTER //
// ./client/assets/scripts/vendor/dynamic-dropdown-mutator.js